import script from "./CordenadorEquipe.vue?vue&type=script&setup=true&lang=js"
export * from "./CordenadorEquipe.vue?vue&type=script&setup=true&lang=js"

import "./CordenadorEquipe.vue?vue&type=style&index=0&id=7c8f3b56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c8f3b56"]])

export default __exports__